import {
	messageToAdminConstants
}from "./constans"
import api from './api'
import {
	defAction
}from "../../../helpers/defaultAction"
import download from "../../../helpers/downloadFile"

export const messageToAdminActions = {
	getPaged,
	create,
	createOrg,
	answer,
	spam,
	read,
	downloadFile,
	clear
}

function getPaged(params){
	const dispatchObj = {
		constants : messageToAdminConstants.GetPaged,
		service   : {
			func   : api.getPaged,
			params : params
		}
	}
	return defAction(dispatchObj)
}

function create(params){
	const dispatchObj = {
		constants : messageToAdminConstants.Create,
		service   : {
			func   : api.create,
			params : params
		}
	}
	return defAction(dispatchObj)
}

function createOrg(params){
	const dispatchObj = {
		constants : messageToAdminConstants.Create,
		service   : {
			func   : api.createOrg,
			params : params
		}
	}
	return defAction(dispatchObj)
}

function read(params){
	const dispatchObj = {
		constants : messageToAdminConstants.Read,
		service   : {
			func   : api.read,
			params : params
		}
	}
	return defAction(dispatchObj)
}

function answer(params){
	const dispatchObj = {
		constants : messageToAdminConstants.Create,
		service   : {
			func   : api.answer,
			params : params
		}
	}
	return defAction(dispatchObj)
}

function spam(params){
	const dispatchObj = {
		constants : messageToAdminConstants.Spam,
		service   : {
			func   : api.spam,
			params : params
		}
	}
	return defAction(dispatchObj)
}
function downloadFile(values){
	const dispatchObj = {
		constants : messageToAdminConstants.DownloadFile,
		service   : {
			func   : api.downloadFile,
			params : values
		},
		sucFunction: (res) => download(res, values.fileName)
	}
	return defAction(dispatchObj)
}

function clear(){
	return (dispatch) => dispatch({
		type: messageToAdminConstants.CLEAR
	})
}